import { render, staticRenderFns } from "./ButtonTertiary.vue?vue&type=template&id=917733e4&"
import script from "./ButtonTertiary.vue?vue&type=script&lang=js&"
export * from "./ButtonTertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports